import scopes from '@/apis/coreIAM/scopes'
import { scopesTypes } from '@/store/mutationTypes'

export default {
    state: {
        all: null,
        current: null,
        fetchAll: {
            pending: false,
            error: null
        },
        fetchOne: {
            pending: false,
            error: null,
        },
        createOne: {
            pending: false,
            error: null,
        },
        updateOne: {
            pending: false,
            error: null,
        },
        deleteOne: {
            pending: false,
            error: null,
        },
    },
    mutations: {
        [scopesTypes.FETCH_ALL_REQUEST]: function (state) {
            state.fetchAll.pending = true;
        },
        [scopesTypes.FETCH_ALL_SUCCESS]: function (state, scopes) {
            state.fetchAll.error = null;
            state.all = scopes;
            state.fetchAll.pending = false;
        },
        [scopesTypes.FETCH_ALL_FAILURE]: function (state, error) {
            state.all = null;
            state.fetchAll.error = error;
            state.fetchAll.pending = false;
        },
        [scopesTypes.FETCH_ONE_REQUEST]: function (state) {
            state.fetchOne.pending = true;
        },
        [scopesTypes.FETCH_ONE_SUCCESS]: function (state) {
            state.fetchOne.error = null;
            state.fetchOne.pending = false;
        },
        [scopesTypes.FETCH_ONE_FAILURE]: function (state, error) {
            state.fetchOne.error = error;
            state.fetchOne.pending = false;
        },
        [scopesTypes.CREATE_ONE_REQUEST]: function (state) {
            state.createOne.pending = true;
        },
        [scopesTypes.CREATE_ONE_SUCCESS]: function (state) {
            state.createOne.error = null;
            state.createOne.pending = false;
        },
        [scopesTypes.CREATE_ONE_FAILURE]: function (state, error) {
            state.createOne.error = error;
            state.createOne.pending = false;
        },
        [scopesTypes.UPDATE_ONE_REQUEST]: function (state) {
            state.updateOne.pending = true;
        },
        [scopesTypes.UPDATE_ONE_SUCCESS]: function (state) {
            state.updateOne.error = null;
            state.updateOne.pending = false;
        },
        [scopesTypes.UPDATE_ONE_FAILURE]: function (state, error) {
            state.updateOne.error = error;
            state.updateOne.pending = false;
        },
        [scopesTypes.DELETE_ONE_REQUEST]: function (state) {
            state.deleteOne.pending = true;
        },
        [scopesTypes.DELETE_ONE_SUCCESS]: function (state) {
            state.deleteOne.error = null;
            state.deleteOne.pending = false;
        },
        [scopesTypes.DELETE_ONE_FAILURE]: function (state, error) {
            state.deleteOne.error = error;
            state.deleteOne.pending = false;
        },
    },
    actions: {
        async fetchAll({ commit }) {
            commit(scopesTypes.FETCH_ALL_REQUEST)
            return new Promise((resolve, reject) => {
                scopes
                    .fetchAll()
                    .then((scopes) => {
                        commit(scopesTypes.FETCH_ALL_SUCCESS, scopes.data);
                        resolve(scopes.data);
                    })
                    .catch((error) => {
                        commit(scopesTypes.FETCH_ALL_FAILURE, error);
                        reject(error);
                    })
            })
        },
        async fetchOne({ commit }, payload) {
            commit(scopesTypes.FETCH_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                scopes
                    .fetchOne(payload.scopeUuid)
                    .then((scope) => {
                        commit(scopesTypes.FETCH_ONE_SUCCESS)
                        resolve(scope.data)
                    })
                    .catch((error) => {
                        commit(scopesTypes.FETCH_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async createOne({ commit }, payload) {
            commit(scopesTypes.CREATE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                scopes
                    .createScope(payload.name, payload.description)
                    .then((scope) => {
                        commit(scopesTypes.CREATE_ONE_SUCCESS)
                        resolve(scope.data)
                    })
                    .catch((error) => {
                        commit(scopesTypes.CREATE_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async updateOne({ commit }, payload) {
            commit(scopesTypes.UPDATE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                scopes
                    .updateScope(payload.scopeUuid, payload.name, payload.description)
                    .then((scope) => {
                        commit(scopesTypes.UPDATE_ONE_SUCCESS)
                        resolve(scope.data)
                    })
                    .catch((error) => {
                        commit(scopesTypes.UPDATE_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async deleteOne({ commit }, payload) {
            commit(scopesTypes.DELETE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                scopes
                    .deleteScope(payload.scopeUuid)
                    .then(() => {
                        commit(scopesTypes.DELETE_ONE_SUCCESS)
                        resolve()
                    })
                    .catch((error) => {
                        commit(scopesTypes.DELETE_ONE_FAILURE)
                        reject(error)
                    })
            })
        },
    }
}